import { render, staticRenderFns } from "./CustomerFollowLogExtends.vue?vue&type=template&id=25a49b2e"
import script from "./CustomerFollowLogExtends.vue?vue&type=script&lang=js"
export * from "./CustomerFollowLogExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports